import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartComponent } from './chart/chart.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [ChartComponent],
  imports: [CommonModule, HighchartsChartModule, MatProgressSpinnerModule],
  exports: [ChartComponent],
})
export class ChartModule {}
